<template>
    <div class="app">
        <div class="footer-box">
            <div class="top-footer-box">
                <div class="top-footer-left">
                    <div class="about-company-box">
                        <div class="newperson">新手上路</div>
                        <div class="newuser">新用户演示</div>
                    </div>
                    <div class="about-company-box">
                        <div class="newperson">付款方式</div>
                        <div class="newuser">支付方式</div>
                        <div class="newuser">支付常见问题</div>
                    </div>
                    <div class="about-company-box">
                        <div class="newperson">配送信息</div>
                        <div class="newuser">订单处理时间</div>
                        <div class="newuser">验货与拒收政策</div>
                    </div>
                    <div class="about-company-box">
                        <div class="newperson">关于我们</div>
                        <div class="newuser">关于我们</div>
                        <div class="newuser">联系我们</div>
                    </div>
                </div>
                <div class="top-footer-center"></div>
                <div
                    class="top-footer-right"
                    @click="jumpIndex"
                >
                    <img
                        src="../assets/image/iocn/917logos.png"
                        alt=""
                    >
                    <div class="footer-rightbox">
                        <div class="footer-right-title">
                            就要吃·厨房网站点
                        </div>
                        <div class="footer-right-content">就要吃·厨房网总部在东北铁岭。提供货到付款、网上支付、我买卡支付等付款方式，为您提供贴心服务。</div>
                    </div>
                </div>
            </div>
            <div class="about-tips-box">
                <ul>
                    <li>关于我们</li>
                    <li>|</li>
                    <li>免责条款</li>
                    <li>|</li>
                    <li>友情链接</li>
                    <li>|</li>
                    <li>客服电话：400-0579-693</li>
                </ul>
            </div>
            <div class="footer-btm-box" style="padding-top: 0.75rem">
                <div class="support-box">技术支持：中国·金华市成信消费服务有限公司&nbsp;|&nbsp;网络实名：就要吃·厨房网</div>
                <div class="letbot_bonts" style="background-color:#252525;margin:0 0">
                    <div class="letbot_bontsback"></div>
                    <p>增值电信业务经营许可证<a
                            href="http://www.cxxf.com/zenzhi.html"
                            target="_blank"
                        >　浙B2-20100042</a>　备案号:　<a
                            href="https://beian.miit.gov.cn/"
                            target="_blank"
                        >浙ICP备05046993号-1</a></p>
                </div>
                <div class="letbtm_box" style="background-color:#252525">917厨房网&nbsp;版权所有&nbsp;中国金华市成信消费服务有限公司</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {

            }
        },
        methods:
        {
            jumpIndex()
            {
                this.$router.push( { path: "/" } )
            },
        }
    }
</script>

<style scoped="scoped">
    .botm_box {
        width: 100%;
        height: 17.8125rem;
        background: #2E2E2E;
    }

    .letbtm_box {
        text-align: center;
        background-color: #303030;
        color: #626262;
        font-size: 12px;
        padding-bottom: 0.6rem;
    }

    .letbot_box {
        width: 100%;
        background-color: #FFFFFF;
        padding-top: 8.125rem;
    }

    .letbot_box_px {
        width: 100%;
        border-bottom: 1px solid #E3E3E3;
        height: 3rem;
        /* margin-top: 8.125rem; */
    }

    .letbot_boxsbox {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .letbot_boxs {
        height: 15rem;
        width: 75rem;
    }

    .letbot_boxtopbox {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .letbot_boxtop {
        width: 26.5625rem;
        text-align: center;
        position: relative;
        top: -2.5rem;
        background-color: #FFFFFF;
    }

    .letbot_boxtoppx {
        width: 2.3125rem;
        height: 0.25rem;
        background: #C8393F;
        position: absolute;
        left: 12rem;
        top: 4rem;
    }

    .letbot_boxico li {
        width: 18.75rem;
        height: 4.9375rem;
        float: left;
    }


    .mosht img {
        display: none;
    }

    .mosht:hover img {
        display: block;
    }

    .letbot_boximg {
        width: 100%;
        height: 14.4375rem;
        /* background-image: url(../assets/img/内页/extension_bj1.png); */
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: space-around;
    }

    .letbot_boxst {
        width: 11.125rem;
        height: 2.6875rem;
        background: #C8393F;
        display: flex;
        justify-content: center;
    }

    .letbot_boxstbox {
        width: 75rem;
        height: 5rem;
        display: flex;
        justify-content: space-between;
        margin-top: 10rem;
    }

    .letbot_boxstbimages {
        background: url(../assets/image/iocn/icon_ty.png) no-repeat -56px -17px;
        width: 22px;
        height: 18px;
        margin: 0.5rem 1rem;
    }

    .letbot_boxstb {
        width: 10.5625rem;
        height: 2.1875rem;
        border: 1px solid #FFFFFF;
        margin-top: 0.25rem;
        font-size: 16px;
        font-family: Microsoft YaHei;
        line-height: 2rem;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: flex;
        cursor: pointer;
    }

    .letbot_boximg_cents {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        width: 11.125rem;
        height: 2.6875rem;
        background: #C8393F;
        display: flex;
        justify-content: center;
        padding-top: 0.3rem;
        position: relative;
        top: -6rem;
        left: 86rem;
    }

    .letbot_boximg_centsBox {
        width: 10.5625rem;
        height: 2.1875rem;
        border: 1px solid #FFFFFF;
        text-align: center;
        line-height: 2rem;
        cursor: pointer;
    }

    .letbot_boxBot {
        width: 100%;
        height: 16.25rem;
        background-color: #3D3D3D;
    }

    .letbot_boxBot_content {
        width: 100%;
        height: 100%;
    }

    .letbot_boxBot_li {
        height: 2.6875rem;
        border: 1px solid #494949;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .letbot_boxBot_li a {
        color: #BBBBBB;
    }

    .letbot_boxBot_li li {
        float: left;
        margin-left: 2rem;
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #BBBBBB;
        cursor: pointer;
    }

    .letbot_boxBotContsA {
        border-right: 1px solid #848484;
        width: 28rem;
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #6A6A6A;
        margin-top: 1rem;
        height: 10rem;
    }

    .letbot_boxBotContsA p {
        margin-left: 2rem;
    }

    .letbot_boxBotContsB {
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #6A6A6A;
    }

    .letbot_boxBotContsB ul {
        float: left;
        margin: 1rem 4rem;
    }

    .letbot_boxBotContsB>ul:nth-of-type(2) {
        margin-top: 3rem;
    }

    .letbot_boxBotContsB li {
        cursor: pointer;
    }

    .letbot_boxBotContsC {
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #6A6A6A;
    }

    .letbot_boxBotContsC img {
        width: 13.75rem;
        height: 4.3125rem;
        margin-left: 1.25rem;
    }

    .letbot_boxBotContsC p {
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #626262;
    }

    .letbot_boxBotContsbox {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .letbot_boxBotConts {
        width: 75rem;
        display: flex;
        justify-content: space-between;
    }

    .letbot_boxBotConts li {
        margin-top: 0.8rem;
    }

    .letbot_boxBotContsP {
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        font-weight: bold;
        color: #FFFFFF;
    }

    .letbot_boxBotContsback {
        background: url(../assets/image/iocn/icon_ty.png) no-repeat -15px -15px;
        width: 20px;
        height: 20px;
        position: absolute;
    }

    .vist_conts_boximgB {
        background: url(../assets/image/iocn/icon_ty.png) no-repeat -98px -18px;
        width: 17px;
        height: 17px;
        position: absolute;
        margin: 0.5rem 0.5rem;
    }

    .letbot_boxliback {
        width: 6.75rem;
        height: 1.9375rem;
        background: #C8393F;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 2rem;
        margin-top: 2rem;
        cursor: pointer;
    }

    .letbot_boxspriteA {
        background: url(../assets/image/iocn/icon_ba.png) no-repeat -38px -1px;
        width: 25px;
        height: 25px;
        position: absolute;
        margin: -0.4rem -2rem;
    }

    .letbot_boxspriteB {
        background: url(../assets/image/iocn/icon_ba.png) no-repeat -72px -3px;
        width: 20px;
        height: 22px;
        position: absolute;
        margin: 0 -1.3rem;
    }

    .letbot_boxspriteP {
        margin: 0 0.37rem;
    }

    .letbot_bonts {
        height: 2.5rem;
        width: 100%;
        background-color: #303030;
        display: flex;
        justify-content: center;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #626262;
        line-height: 2rem;
        padding-top: 0.5rem;
        margin-top: -2.7rem;
    }

    .letbot_bontsback {
        background: url(../assets/image/iocn/icon_ba.png) no-repeat -7px 0;
        width: 26px;
        height: 26px;
    }

    a:hover {
        color: #C8393F;
    }

    a {
        color: #5E5E5E;
    }
    .xkz-box {
        margin-top: 0.625rem;
    }

    .footer-btm-box {
        width: 100%;
        height: 5.875rem;
        background-color: #252525;
        text-align: center;
        color: #595959;
        font-size: 12px;
        padding-top: 1.75rem;
    }

    .about-tips-box li:nth-of-type(2),
    .about-tips-box li:nth-of-type(4),
    .about-tips-box li:nth-of-type(6) {
        margin: 0 1.25rem;
    }

    .about-tips-box li {
        color: #8E8D8D;
        font-size: 14px;
        font-weight: 400;
    }

    .about-tips-box ul {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2.25rem;
    }

    .about-tips-box {
        background-color: #373737;
        margin-top: 4.25rem;
    }

    .footer-rightbox {
        width: 15.75rem;
        margin-left: 1.5rem;
    }

    .footer-right-content {
        color: #999999;
        font-size: 14px;
        font-weight: bold;
        text-indent: 2em;
    }

    .footer-right-title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 1.25rem;
    }

    .top-footer-right {
        align-items: center;
    }

    .top-footer-right img {
        /* width: 13.75rem;
		height: 4.3125rem; */
        width: 12.0625rem;
        height: 3.75rem;
    }

    .footer-box {
        width: 100%;
        height: auto;
        padding-top: 4.25rem;
        background-color: #FFFFFF;
        /* border-top: 0.0625rem solid #E7E7E7; */
    }

    .top-footer-center {
        width: 1px;
        height: 6.75rem;
        background-color: #BFBFBF;
        margin-left: 3.125rem;
        margin-right: 7.375rem;
    }

    .about-company-box {
        margin-right: 3.6875rem;
    }

    .top-footer-left {
        padding-top: 0.625rem;
    }

    .top-footer-left,
    .top-footer-right {
        display: flex;
        height: 6.75rem;
    }

    .newuser {
        color: #999999;
        font-size: 14px;
        font-weight: bold;
        margin-top: 0.625rem;
    }

    .newperson {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 1.25rem;
    }

    .top-footer-box {
        display: flex;
        justify-content: center;
    }
</style>